import type { FreelancerSubmitApplicationPageLocales } from '../types';

const freelancerSubmitApplicationPageLocales: FreelancerSubmitApplicationPageLocales =
  {
    clickHere: 'Klik dan hier',
    headline:
      'Bedankt voor je aanmelding. We gaan aan de slag om de documenten te verifiëren. Als alles goed gaat, nodigen we je via een mail uit voor een gesprek om je aanmelding door te nemen. Let op: de email met deze link kan je bij je ongewenste mail terecht komen. Houd die dus ook in de gaten!',
    instructions1:
      'Je hebt nu alle stappen doorlopen van het aanmeldingsproces. Is het gelukt om alle benodigde documenten te uploaden? Wij gaan dan aan de slag om deze documenten te controleren.',
    instructions2:
      'Is het nog niet gelukt om alles te uploaden? Je kan binnen 30 dagen de resterende bestanden in je "mijn Tadaah" uploaden.',
    instructions3:
      'Let op: doe je dit niet, dan verwijderen we na 30 dagen al je gegevens.',
    instructions4:
      'Als alle documenten in orde zijn, ontvang je van ons een link om je aan te melden voor onze online welkomstbijeenkomst. Daarin maken we persoonlijk kennis met elkaar en leggen we uit hoe werken via Tadaah werkt. Daarnaast volg je onze online welkomst training. Zodat jij goed voorbereid aan de slag kan als freelancer en al je mogelijke vragen beantwoord zijn. ',
    instructions5:
      'Tot die tijd is het verstandig om alvast na te denken over een arbeidsongeschiktheidsverzekering, een boekhoudpakket, en je in te lezen in de regelgeving met betrekking tot de Kleineondernemersregeling(KOR)',
    instructionsHeader: 'Welkomstbijeenkomst',
    learnMore: 'Wil je alvast meer leren over Tadaah?',
    readInstructions: 'Liever de instructies lezen?',
    title: 'Aanmelding Verstuurd',
  };

export default freelancerSubmitApplicationPageLocales;
